import styled from 'styled-components';
import { uuid } from '@elfsight/lib-utils';
import { getLinearGradientColor } from './get-linear-gradient-color';

type AvatarStubProps = {
  backgroundColor: string;
};

export function AvatarStub({ backgroundColor }: AvatarStubProps) {
  const { hslFirstLinearColor, hslSecondLinearColor } =
    getLinearGradientColor(backgroundColor);

  const id = uuid();
  const firstLinearId = `first_linear_${id}`;
  const secondLinearId = `second_linear_${id}`;

  return (
    <StyledAvatarStub
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Avatar stub icon</title>
      <path
        d="M12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2Z"
        fill={`url(#${firstLinearId})`}
      />
      <path
        d="M12 13C9.60453 13 7.42467 13.6937 5.82227 14.6715C5.02143 15.1602 4.33788 15.7363 3.84397 16.3615C3.35805 16.9767 3 17.713 3 18.5C3 19.3449 3.41114 20.0111 4.00266 20.4859C4.56324 20.9359 5.30182 21.2336 6.08716 21.4416C7.66466 21.8593 9.77101 22 12 22C14.229 22 16.3353 21.8593 17.9128 21.4416C18.6982 21.2336 19.4368 20.9359 19.9973 20.4859C20.5889 20.0111 21 19.3449 21 18.5C21 17.713 20.642 16.9767 20.156 16.3615C19.6621 15.7363 18.9786 15.1602 18.1777 14.6715C16.5753 13.6937 14.3955 13 12 13Z"
        fill={`url(#${secondLinearId})`}
      />

      <defs>
        <linearGradient id={firstLinearId} gradientUnits="userSpaceOnUse">
          <stop stopColor={hslFirstLinearColor} />
          <stop offset="1" stopColor={hslSecondLinearColor} />
        </linearGradient>
        <linearGradient id={secondLinearId} gradientUnits="userSpaceOnUse">
          <stop stopColor={hslFirstLinearColor} />
          <stop offset="1" stopColor={hslSecondLinearColor} />
        </linearGradient>
      </defs>
    </StyledAvatarStub>
  );
}

const StyledAvatarStub = styled.svg`
  fill: inherit;
  width: 56%;
  height: 56%;
`;
